export class Response_1 {
    constructor(
        public isSetDataQualityTarget: boolean | null,
        public details: string | null,
    ) {
        this.isSetDataQualityTarget = isSetDataQualityTarget;
        this.details = details;
    }

    static init = () => new Response_1(null, null);
}